import { ContactVenuePayload, NotifyMePayload } from "./venue-content.interface";

export const notifyMePayload: NotifyMePayload = {
    "data": {
        "type": "notifications",
        "id": null,
        "attributes": {
            "endpoint": "venues",
            "email": ""
        },
        "relationships": {
            "conditions": {
                "data": [
                    {
                        "id": "new_1",
                        "type": "conditions"
                    }
                ]
            }
        }
    },
    "included": [
        {
            "id": "new_1",
            "type": "conditions",
            "attributes": {
                "name": "venue",
                "value": ""
            }
        }
    ]
}

export const notifyMeResponse = {
    "data": {
        "type": "notifications",
        "id": "13",
        "attributes": {
            "endpoint": "venues"
        },
        "relationships": {
            "conditions": {
                "data": [
                    {
                        "type": "conditions",
                        "id": "63981984890ce"
                    }
                ]
            }
        }
    },
    "included": [
        {
            "type": "conditions",
            "id": "63981984890ce",
            "attributes": {
                "name": "venue",
                "value": "22539"
            }
        }
    ]
}

export const contactVenuePayload: ContactVenuePayload = {
    "data": {
        "type": "contact-venues",
        "id": null,
        "attributes": {
            "venue": 1234,
            "contacted": false
        }
    }
}
